import { Notification } from '@hec/models';

export interface NotificationState {
  notifications: Notification[];
}

export const notificationInitialState: NotificationState = {
  notifications: [],
}
